<app-stack-icons
    baseIconTransform="shrink-2"
    size="lg"
    topIconTransform="shrink-6 up-3 right-3"
    [baseIcon]="['far', 'draw-polygon']"
    [class]="isEnabled() ? 'cursor-pointer' : 'cursor-not-allowed text-custom-dark-grey'"
    [class.text-black]="isEnabled() && !isActive()"
    [class.text-custom-blue]="isEnabled() && isActive()"
    [clickable]="isEnabled()"
    [matTooltip]="tooltipKey() ? (tooltipKey()! | transloco) : ''"
    [topIcon]="['fas', 'pen']"
    (stackClick)="onClick($event)" />
